"use client";

import Link from "next/link";
import { useRouter, usePathname } from "next/navigation";
import { useWindowSize } from "usehooks-ts";
import { Button } from "@/components/ui/button";
import { PlusIcon } from "@/components/icons";
import { SidebarUserNav } from "@/components/sidebar-user-nav";
import { SidebarToggle } from "@/components/sidebar-toggle";
import { useSidebar } from "@/components/ui/sidebar";
import { memo, useState, useEffect, useMemo } from "react";
import BuyCreditsModal from "./BuyCreditsModal";
import UpgradePlan from "./upgrade-plan";
import { ChevronDown, Zap } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";
import { useSelector, useDispatch } from "react-redux";
import { setActiveNavItem, setActiveTab, setActiveModel } from "@/store/mainSlice";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSub, DropdownMenuSubTrigger, DropdownMenuSubContent
} from "@/components/ui/dropdown-menu";
import { menuOptions, modelOption } from "@/lib/dropDownData";

function PureChatHeader({
  chatId,
  selectedModelId,
  selectedVisibilityType,
  isReadonly,
  session,
  children
}) {
  const router = useRouter();
  const pathname = usePathname();
  const isProjectPage = pathname.startsWith("/project");
  const { width: windowWidth } = useWindowSize();
  const { user_ai_limit } = useSelector((state) => state.main);
  const dispatch = useDispatch();
  const { userIdParent, userData, activeTab, activeModel } = useSelector((state) => state.main);
  const [mounted, setMounted] = useState(false);
  const [showBuyCreditsModal, setShowBuyCreditsModal] = useState(false);
 const [showUpgradePopup, setShowUpgradePopup] = useState(false);
  const effectiveTab = isProjectPage
  ? null          // project page → no model selected
  : activeTab ?? "Page Builder";
  const selectedModel = activeModel ?? "gpt-4o-mini";
  const isHomePage = pathname === "/";
  const isAgents =  pathname ==="/explore-agents";
const isSubscribed = userData?.subscriptionStatus === "active";
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <>
      <header className="flex sticky top-0 py-1.5 md:px-2 px-4 items-center md:justify-between z-30 bg-background">
        {mounted && windowWidth < 768 && <SidebarToggle className="h-6 w-6" />}

        {/* ---- Desktop header content ---- */}
        <div className="hidden md:flex items-center gap-2 w-full">

          <div className="flex ml-auto items-center gap-2">
            <Tooltip>
              <TooltipTrigger asChild>
                <span className="text-[14px] text-dark dark:text-white cursor-default">
                  Remaining Credits: {user_ai_limit ?? 0}
                </span>
              </TooltipTrigger>
              <TooltipContent align="center">
                <p className="text-[12px] max-w-[260px]">
                  <span className="text-accent">⚡</span> Each prompt costs{" "}
                  <b>1 credit</b>. You have{" "}
                  <span className="text-emerald-400 dark:text-emerald-300 font-semibold">
                    {user_ai_limit} credits
                  </span>{" "}
                  remaining.
                </p>
              </TooltipContent>
            </Tooltip>

            <Button
              className="group button ml-auto bg-transparent p-0 text-dark text-[14px] rounded-[50px] px-3 hover:bg-muted hover:bg-accent h-fit px-5 py-2 dark:bg-white bg-black text-xs text-white dark:text-black dark:hover:text-white dark:hover:bg-black hover:text-foreground flex items-center gap-1 rounded-[50px] ml-3"
              onClick={() => {
                dispatch(setActiveNavItem("z-[46]"));
                setShowBuyCreditsModal(true);
              }}
            >
              <span>
                <Zap />
              </span>
              Buy Credits
            </Button>
          </div>

          <div className="flex items-center gap-2">{children}</div>
        </div>

        {/* ---- Mobile header content ---- */}
        <div className="flex items-center gap-2 justify-start md:flex-none flex-1 md:hidden">
          {/* <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button className="text-[18px] leading-[1.25] px-2.5 py-1 bg-transparent dark:text-white dark:hover:bg-[#3a3a3a] text-black hover:bg-accent">
                {activeTab || "Page Builder"}
                <ChevronDown
                  size={18}
                  className="dark:text-white text-black cursor-pointer"
                />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="w-44">
              <DropdownMenuItem
                onClick={() => {
                  dispatch(setActiveTab("Page Builder"));
                }}
              >
                Page Builder
              </DropdownMenuItem>
              <DropdownMenuItem
                onClick={() => {
                  dispatch(setActiveTab("Card Maker"));
                }}
              >
                Card Maker
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu> */}


          <Button
            variant="outline"
            className="h-8 px-2 md:ml-0 ml-auto"
            onClick={() => {
              // Mobile New Chat → reset to default Page Builder experience
              dispatch(setActiveTab(null));
              router.push("/");
              router.refresh();
            }}
          >
            <PlusIcon />
            <span>New Chat</span>
          </Button>

          <SidebarUserNav user={userIdParent} className="group w-auto" />
        </div>

        {showBuyCreditsModal && (
          <BuyCreditsModal
            show={showBuyCreditsModal}
            handleClose={() => setShowBuyCreditsModal(false)}
            userDetail={userData}
          />
        )}
              {showUpgradePopup && userData && (
                <UpgradePlan
                  show={showUpgradePopup}
                  handleClose={() => setShowUpgradePopup(false)}
                  userDetail={userData}
                />
              )}
      </header>
{/* 
      {isHomePage && (
        <div
          className="max-w-4xl mx-auto mt-10 mb-14 
px-8 py-6 gap-2
bg-white/5
border border-white/10
rounded-3xl
backdrop-blur-xl
shadow-lg shadow-indigo-500/10
flex items-center justify-between"
        >
          <div className="max-w-[75%]">
            <h3 className="text-white font-semibold text-xl">
              📁 Build Your AI Agent in Minutes with Varnz
            </h3>
            <p className="text-gray-400 text-base">
              Upload your documents, train your AI, and embed a smart chatbot anywhere. No coding. Your AI agent is ready to answer instantly.
            </p>
          </div>

          {isSubscribed ? (
      <button
        onClick={() => router.push("/create-agent")}
        className="bg-white/90 text-black px-6 py-3 rounded-xl 
        font-semibold text-sm 
        hover:bg-white hover:scale-105 
        transition-all duration-200"
      >
        Create Agent
      </button>
    ) : (
      <button
        onClick={() => setShowUpgradePopup(true)}
        className="bg-white/90 text-black px-6 py-3 rounded-xl 
        font-semibold text-sm 
        hover:bg-white hover:scale-105 
        transition-all duration-200"
      >
        Subscribe Now
      </button>
    )}
        </div>
      )} */}


      {/* ---- Mobile credit stripe ---- */}
      {mounted && windowWidth < 768 && (
        <div className="flex justify-center items-center text-[14px] bg-muted dark:bg-background text-dark dark:text-white py-2 border-b border-white/10">
          <span>
            Remaining Credits:{" "}
            <span className="font-semibold text-emerald-500 dark:text-emerald-300">
              {user_ai_limit ?? 0}
            </span>
          </span>
          <Button
            className="bg-black text-white dark:bg-white dark:text-black text-xs px-3 py-2 rounded-full hover:bg-accent dark:hover:bg-black dark:hover:text-white gap-1 h-auto ml-3"
            onClick={() => {
              dispatch(setActiveNavItem("z-[46]"));
              setShowBuyCreditsModal(true);
            }}
          >
            <Zap className="h-4 w-4" />
            Buy Credits
          </Button>
        </div>
      )}
    </>
  );
}

export const ChatHeader = memo(
  PureChatHeader,
  (prev, next) =>
    prev.selectedModelId === next.selectedModelId &&
    prev.children === next.children
);
